module.exports = require("angular-typescript-validation");


//////////////////
// WEBPACK FOOTER
// external "angular-typescript-validation"
// module id = 21
// module chunks = 0